import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { conciergeList } from '@/hooks/commons/common/useConciergePulldown';

export let conciergeId: number;
export let loginUserName: string;
export let setLoginUserName: Dispatch<SetStateAction<string>>;

export const useLoginUserName = (_conciergeId: number | null) => {
  conciergeId = _conciergeId ?? -1;
  [loginUserName, setLoginUserName] = useState(getUserNameById(_conciergeId));
  useEffect(() => {
    setLoginUserName(getUserNameById(_conciergeId));
  }, [conciergeList]);
};

const getUserNameById = (id: number | null): string => {
  return conciergeList?.find((concierge) => concierge.value === id)?.text ?? '';
};
